import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EActionTypes } from '../../constants/actionTypes/pickedSpecialist';
import { ISpecialistCatalogListingSchema } from '../../repositories/demand/entities/specialist_catalog/SpecialistCatalogListingSchema';
import { ITypedReduxAction } from '../../types/redux/actionType';

export const addSpecialist = actionGenerator<EActionTypes.ADD_SPECIALIST, ISpecialistCatalogListingSchema>(
  EActionTypes.ADD_SPECIALIST,
);
export const removeSpecialist = actionGenerator<EActionTypes.REMOVE_SPECIALIST, string>(EActionTypes.REMOVE_SPECIALIST);

export type TPickedSpecialist =
  | ITypedReduxAction<EActionTypes.ADD_SPECIALIST, ISpecialistCatalogListingSchema>
  | ITypedReduxAction<EActionTypes.REMOVE_SPECIALIST, string>;
